<template>

  <div class="loginDiv" @keydown.enter.stop="login()">

    <v-container class="loginFrame">
      <v-layout row class="text-xs-left">
        <div>
          <img class="ntstLogo" src="../assets/images/Netsmart_logo_people_only.png">
        </div>
        <div>
          <p class="netsmartName">Netsmart</p>
          <p class="appName">BedBoard</p>
        </div>
      </v-layout>
      <v-flex>
        <div class="ntstValueLabel">Scope</div>
        <v-text-field :readonly="isBusy" outline required v-model="input.scope"></v-text-field>
      </v-flex>

      <v-flex>
        <div class="ntstValueLabel">Username</div>
        <v-text-field :readonly="isBusy" append-icon="person" outline required v-model="input.userName"></v-text-field>
      </v-flex>

      <v-flex>
        <div class="ntstValueLabel">Password</div>
        <v-text-field :readonly="isBusy" append-icon="lock" :type="'password'" outline required v-model="input.password"></v-text-field>
      </v-flex>

      <v-flex>
        <v-checkbox label="Remember Username" v-model="rememberMe" color="#757575"></v-checkbox>
      </v-flex>

      <v-flex class="text-xs-center">
        <v-btn v-if="!isBusy" class="ntstAppButton" style="margin-bottom: 28px;" @click.stop="login()">Login</v-btn>
        <busy-animation v-if="isBusy"></busy-animation>
        <div v-if="isBusy" class="ntstLoadingLabel">{{ statusMessage }}</div>
      </v-flex>
      <v-alert :value="errorMessage" type="error">{{ errorMessage }}</v-alert>
    </v-container>
  </div>

</template>

<script>
import moment from 'moment';

import appSettings from '../appSettings';

import BusyAnimation from './BusyAnimation.vue';

export default {
  components: {
    'busy-animation': BusyAnimation
  },
  data() {
    return {
      errorMessage: '',
      input: {
        scope: '',
        userName: '',
        password: ''
      },
      isBusy: false,
      rememberMe: false,
      statusMessage: ''
    };
  },
  created() {
    this.isBusy = false;
    this.input.scope = this.$sdkAuth.getScope('local');
    this.rememberMe = this.$sdkAuth.getRememberMe('local');
    this.input.userName = this.$sdkAuth.getUserName('local');
    if (!this.input.userName) {
      this.input.userName = '';
    }
    if (this.$route.params && this.$route.params.message) {
      this.errorMessage = this.$route.params.message;
    }
  },

  methods: {
    login() {
      try {
        this.isBusy = true;
        this.errorMessage = '';
        if (
          this.input.scope !== ''
          && this.input.userName !== ''
          && this.input.password !== ''
        ) {
          this.statusMessage = 'Authorizing...';
          const loginParameters = {
            authenticationType: 'UsernamePassword',
            scope: this.input.scope,
            userName: this.input.userName,
            password: this.input.password,
            rememberMe: this.rememberMe
          };
          this.$sdkAuth
            .login(loginParameters)
            .then(() => {
              this.$eventbus.$emit('LoginSuccessful');
            })
            .catch((err) => {
              if (err && err.message) {
                this.$log.debug(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
              } else {
                this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
              }
              this.errorMessage = 'Unable to login.';
              this.isBusy = false;
            });
        } else {
          this.errorMessage = 'A scope, userName, and password must be present';
          this.$log.error(`[${moment().format(appSettings.logDateFormat)}] A scope, userName, and password must be present`);
          this.isBusy = false;
        }
      } catch (err) {
        this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ${err.message}`);
        this.isBusy = false;
      }
    }
  }
};
</script>

<style lang="scss">
.loginDiv {
  height: 100%;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-top: 40px;
  padding-bottom: 40px;
  background-color: #f5f5f5;
  margin: 0px auto;
  background: url("../assets/images/login_background.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.appName {
  margin-top: -35px;
  color: #14609b;
  font-family: "Montserrat";
  font-size: 32px;
}
.loginFrame {
  background-color: #ffffff;
  margin: 0px;
  max-width: 423px;
}
.netsmartName {
  color: #082155;
  font-family: "Montserrat";
  font-size: 44px;
  font-weight: 700;
}
.ntstLogo {
  margin-left: 10px;
  margin-top: 10px;

  width: 100px;
}
</style>
